import { createContext } from 'react'
import type { FeatureKey, TierId } from '../services/subscriptionGuard'
import type { LifetimeEntitlement } from '../config/lifetimeEntitlements'

export interface SubscriptionContextValue {
  plan: TierId
  usage: Record<FeatureKey, number>
  reservedUsage: Record<FeatureKey, number>
  entitlements: LifetimeEntitlement[]
  isLoading: boolean
  checkLimit: (featureKey: FeatureKey, requestedAmount?: number) => boolean
}

export const SubscriptionContext = createContext<SubscriptionContextValue | undefined>(undefined)
